import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/incognito.jpg'


const _hoisted_1 = { class: "mobileMode py-3 px-5 flex overflow-y-auto space-x-5 flex-grow" }
const _hoisted_2 = { class: "mx-5 mb-4 p-2 px-5 bg-white dark:bg-gray-800 w-100 rounded-lg flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Share", -1)
const _hoisted_4 = { class: "ml-auto flex overflow-y-auto space-x-2" }
const _hoisted_5 = { class: "mx-5 mb-4 py-2 bg-white dark:bg-gray-800 w-100 rounded-lg" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "flex overflow-y-auto space-x-5 items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-[45px] rounded-full"
  }),
  /*#__PURE__*/_createElementVNode("h6", null, "Anonymous")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", { class: "transition text-white duration-150 ml-auto flex overflow-y-auto space-x-2 cursor-pointer bg-primary-400 hover:bg-primary-500 py-1 px-5 rounded-lg appFont" }, " Send ", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoreDotsIcon = _resolveComponent("MoreDotsIcon")!
  const _component_IconCirlce = _resolveComponent("IconCirlce")!
  const _component_DownloadIcon = _resolveComponent("DownloadIcon")!
  const _component_Sheet = _resolveComponent("Sheet")!

  return (_openBlock(), _createBlock(_component_Sheet, {
    class: "share-modal-color",
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    visibility: _ctx.shareSheet,
    addPadX: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_IconCirlce, { title: "Report" }, {
          default: _withCtx(() => [
            _createVNode(_component_MoreDotsIcon, { class: "text-gray-600 dark:text-gray-400" })
          ]),
          _: 1
        }),
        _createVNode(_component_IconCirlce, { title: "Download" }, {
          default: _withCtx(() => [
            _createVNode(_component_DownloadIcon, { class: "text-gray-600 dark:text-gray-400" })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_IconCirlce, null, {
            default: _withCtx(() => [
              _createVNode(_component_MoreDotsIcon)
            ]),
            _: 1
          }),
          _createVNode(_component_IconCirlce, null, {
            default: _withCtx(() => [
              _createVNode(_component_MoreDotsIcon)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
          return _createElementVNode("div", {
            class: "transition p-2 px-5 duration-150 flex items-center hover:bg-gray-200 dark:hover:bg-gray-700",
            key: i
          }, _hoisted_8)
        }), 64))
      ])
    ]),
    _: 1
  }, 8, ["visibility"]))
}